import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild } from '@angular/router';

import { Session } from 'app/shared/services/session/session.service';
import { ActiveUser } from 'app/shared/services/user/active-user.model';
import { GlobalRole } from 'app/shared/services/user/base-user.model';

@Injectable()
export class AdminAuthGuard implements CanActivate, CanActivateChild {
  private _user: ActiveUser;

  constructor(private _session: Session) {}

  checkIfIsAdmin() {
    return this._session.user().then((user) => {
      this._user = user;
      return this._user.globalRole.level > GlobalRole.Client;
    });
  }

  canActivate() {
    return this.checkIfIsAdmin();
  }

  canActivateChild() {
    return this.checkIfIsAdmin();
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/user/admin-auth-guard.ts